import { render, staticRenderFns } from "./PowerladderCart.vue?vue&type=template&id=3137fb35&scoped=true"
import script from "./PowerladderCart.vue?vue&type=script&lang=js"
export * from "./PowerladderCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137fb35",
  null
  
)

export default component.exports